export const blockIconsHouseholdTableRestaurantNew = (
	<span className='material-symbols-outlined'>table_restaurant</span>
);
